// WRITE FUNCTION THAT ARE STATIC AND CAN BE REUSED IN WHOLE PROJECT
// Todo move stuff from this file to common/utils.js
import _ from "lodash";

export function getEnvironmentName(){
  let environment
  if (!process.env.REACT_APP_ENVIRONMENT && window.location.host.includes("localhost")){
    environment = "development"
  }else{
    environment = process.env.REACT_APP_ENVIRONMENT ? process.env.REACT_APP_ENVIRONMENT : window.location.host.split(".")[0];
  }
  return environment
}
export const LUCIA_TENANT_NAME = "lucia";
export const ARROW_KEYS = [
  37, // Left arrow
  38, // Up arrow
  39, // Right arrow
  40 // Down arrow
];
export const DELETION_KEYS = [
  8, // Backspace
  46 // Delete
];

export function getUserDisplayName(cognitoUser) {
  return _.get(
    cognitoUser,
    "attributes.nickname",
    _.get(cognitoUser, "attributes.given_name", _.get(cognitoUser, "attributes.email")) +
      " " +
      _.get(cognitoUser, "attributes.family_name", "")
  );
}

export function replaceLastOccurrenceInString(string, match, replacement) {
  console.log(string)
  console.log(match)
  console.log(replacement)

  if (!string || !match || !replacement) {
    return string;
  }
  const matchStartIdx = string.lastIndexOf(match);

  if (matchStartIdx === -1) {
    return string;
  }
 

  const matchEndIdx = matchStartIdx + match.length;
  console.log(string.slice(0, matchStartIdx) + replacement + string.slice(matchEndIdx))
  return string.slice(0, matchStartIdx) + replacement + string.slice(matchEndIdx);
}

/**
 * Check if string is in upper case.
 * Note that the function returns false for strings containing *only* numbers (e.g. "35") or *only*
 * punctuation (e.g. "?!").
 */
export function isUpperCase(str) {
  try {
    return str === str.toUpperCase() && str !== str.toLowerCase();
  } catch (e) {
    return false;
  }
}

export function createQS(params) {
  return Object.keys(params)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
    .join("&");
}
